// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b9b12e6","455":"369b7b8b","977":"8feed0c9"}[chunkId] + ".chunk.js";
};